import SendbirdApp from '@sendbird/uikit-react/App';
import SendbirdProvider from "@sendbird/uikit-react/SendbirdProvider";

import '@sendbird/uikit-react/dist/index.css';
import './App.css';

function App() {
  const searchParams = new URLSearchParams(document.location.search)

  return (
    <div className="App">
      <SendbirdApp
        appId='239F639E-5AE0-4CAF-9320-DA0A510AB7A2'
        userId={searchParams.get('user_id') || 'guest'}
        accessToken='bb023f832375352acf02df157319455ebe8426c2'
      />
    </div>
  );
}

export default App;
